export const defaultState = {
  myExitRequests: [],
  rehabilitations: [],
  exitTypes: [],
};
